import { NumberInput, maxValue, required } from "react-admin";
import React from "react";
import { get } from "lodash";
import { getMessage } from "../../utils/validation";
import moment from "moment";
import { useFieldLabel } from "ra-friendsofbabba";
import { validate } from "../useValidation";

const maxDuration =
  (source, message = "ra.validation.maxValue") =>
  (value, values) => {
    const { min, duration } = validate(values);

    // Recupero la data di inizio dell'attività e calcolo
    // quanti mesi è possibile utilizzare per la stessa
    // rispetto al numero massimo consentito all'interno del WP.
    const startDateSource = source.replace(".duration", ".start_date");
    const startDate = moment(get(values, startDateSource));
    const maxDuration =
      min.clone().add(duration, "months").diff(startDate, "months") + 1;
    return value <= maxDuration
      ? undefined
      : getMessage(message, { max: maxDuration }, value, values);
  };

const ActivityDurationInput = ({ ...props }) => {
  // const form = useFormState();
  const fieldLabel = useFieldLabel(props);
  // const { min, duration } = useValidation(form);
  // const maxDuration = useMemo(() => {
  //   // Recupero la data di inizio dell'attività e calcolo
  //   // quanti mesi è possibile utilizzare per la stessa
  //   // rispetto al numero massimo consentito all'interno del WP.
  //   const startDateSource = props.source.replace(".duration", ".start_date");
  //   const startDate = moment(get(form.values, startDateSource));
  //   const maxDuration =
  //     min.clone().add(duration, "months").diff(startDate, "months") + 1;
  //   return maxDuration > 0 ? maxDuration : 0;
  // }, [min, duration, props, form.values]);

  return (
    <NumberInput
      {...props}
      label={fieldLabel("duration")}
      defaultValue={1}
      validate={[required(), maxDuration(props.source), maxValue(maxDuration)]}
    />
  );
};
export default ActivityDurationInput;
